// copied from calling-remote-app/static/js/navigation/hooks/useShowCriticalErrorAlert.ts
// does not include open remote handling
import { useMemo } from 'react';
import { getCriticalFailureReason } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { CriticalFailureReasons } from 'calling-cross-tab-library/constants/CriticalFailureReasons';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
export const useHasCriticalError = () => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const criticalFailureReason = getCriticalFailureReason(widgetDetails) || CriticalFailureReasons.NONE;
  const hasCriticalError = useMemo(() => criticalFailureReason !== CriticalFailureReasons.NONE && criticalFailureReason !== CriticalFailureReasons.FETCH_TOKEN_ERROR && criticalFailureReason !== CriticalFailureReasons.MICROPHONE_PERMISSION_ERROR, [criticalFailureReason]);
  return {
    hasCriticalError
  };
};